import { createAsyncThunk } from '@reduxjs/toolkit'
import { API_BASE_URL, BASE_URL } from '../../constant'
import { clearAdminData } from '../reducers/authReducer'
import axios from 'axios'

axios.defaults.withCredentials = true;

/**
 * LOGIN ADMIN
 */
export const signIn = createAsyncThunk('admin/signIn', async (data, { rejectWithValue }) => {
    try {
        // Await CSRF cookie setup
        await axios.get(`${BASE_URL}/sanctum/csrf-cookie`);
        const res = await axios.post(`${API_BASE_URL}/signin`, data, {});
        console.log("Action data:", res.data);
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * LOGOUT ADMIN
 */
export const signOut = createAsyncThunk('admin/signOut', async (token, { dispatch, rejectWithValue }) => {
    try {
        const res = await axios.post(`${API_BASE_URL}/signout`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        dispatch(clearAdminData());
        return res.data;
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(clearAdminData());
            return rejectWithValue('Session expired. Please log in again.');
        }
        return rejectWithValue(error.response?.data || 'Failed to sign out');
    }
});

/**
 * FORGOT PASSWORD
 */
export const forgotPassword = createAsyncThunk('admin/forgotPassword', async (data, { rejectWithValue }) => {
    try {
        // Await CSRF cookie setup
        await axios.get(`${BASE_URL}/sanctum/csrf-cookie`);
        const res = await axios.post(`${API_BASE_URL}/forgot-password`, data, {});
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * RESET PASSWORD
 */
export const resetPassword = createAsyncThunk('admin/resetPassword', async (data, { rejectWithValue }) => {
    try {
        // Await CSRF cookie setup
        await axios.get(`${BASE_URL}/sanctum/csrf-cookie`);
        const res = await axios.post(`${API_BASE_URL}/reset-password`, data, {});
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});